import PropTypes from 'prop-types'
import Sort from './Sort'

function ListingsHeader({ items, resultsTotal, view, setView, filters, handleFilter, isFiltered, handleReset }) {
  return (
    <div
      id="listings-header"
      className={`items-center justify-between pt-6 md:pt-16 md:flex ${
        resultsTotal === 0 ? 'invisible h-0 pointer-events-none' : ''
      }`}
    >
      <div className="flex flex-col font-normal lg:flex-row">
        <span>
          Showing {items.length.toString().padStart(2, '0')} of {resultsTotal.toString().padStart(2, '0')}
        </span>
        {isFiltered && (
          <div className="sm-down:mt-4 lg:ml-4">
            <button type="button" className="text-sm font-medium hover:underline text-brand-red" onClick={handleReset}>
              Try Another Search
            </button>
          </div>
        )}
      </div>

      <div className="items-center mt-6 md:flex md:mt-0">
        <div>
          <Sort name="sort" value={filters.sort} handleFilter={handleFilter} />
        </div>

        <div className="flex sm-down:hidden space-x-4 md:ml-8 md:space-x-6">
          <button
            type="button"
            onClick={() => setView('list')}
            className={`w-6 h-6 transition-colors ${
              view === 'list' ? 'text-brand-red' : 'text-gray-300 hover:text-gray-400'
            }`}
          >
            <svg viewBox="0 0 512 512" fill="currentColor">
              <path d="M506 114H134a6 6 0 01-6-6V84a6 6 0 016-6h372a6 6 0 016 6v24a6 6 0 01-6 6zm6 154v-24a6 6 0 00-6-6H134a6 6 0 00-6 6v24a6 6 0 006 6h372a6 6 0 006-6zm0 160v-24a6 6 0 00-6-6H134a6 6 0 00-6 6v24a6 6 0 006 6h372a6 6 0 006-6zM84 120V72c0-6.627-5.373-12-12-12H24c-6.627 0-12 5.373-12 12v48c0 6.627 5.373 12 12 12h48c6.627 0 12-5.373 12-12zm0 160v-48c0-6.627-5.373-12-12-12H24c-6.627 0-12 5.373-12 12v48c0 6.627 5.373 12 12 12h48c6.627 0 12-5.373 12-12zm0 160v-48c0-6.627-5.373-12-12-12H24c-6.627 0-12 5.373-12 12v48c0 6.627 5.373 12 12 12h48c6.627 0 12-5.373 12-12z" />
            </svg>
          </button>

          <button
            type="button"
            onClick={() => setView('grid')}
            className={`w-6 h-6 transition-colors ${
              view === 'grid' ? 'text-brand-red' : 'text-gray-300 hover:text-gray-400'
            }`}
          >
            <svg viewBox="0 0 512 512" fill="currentColor">
              <path d="M0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80zm320-16v106.667H192V64h128zm160 245.333H352V202.667h128v106.666zm-160 0H192V202.667h128v106.666zM32 202.667h128v106.667H32V202.667zM160 64v106.667H32V80c0-8.837 7.163-16 16-16h112zM32 432v-90.667h128V448H48c-8.837 0-16-7.163-16-16zm160 16V341.333h128V448H192zm160 0V341.333h128V432c0 8.837-7.163 16-16 16H352zm128-277.333H352V64h112c8.837 0 16 7.163 16 16v90.667z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}

ListingsHeader.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  resultsTotal: PropTypes.number,
  view: PropTypes.string,
  setView: PropTypes.func,
  filters: PropTypes.object,
  handleFilter: PropTypes.func,
  isFiltered: PropTypes.bool,
  handleReset: PropTypes.func,
}

export default ListingsHeader
